import React from "react";

const MAP = {
    Confermato: "bg-[#16A34A]/10 text-[#16A34A] border-[#16A34A]/30",
    Conosciuto: "bg-[#16A34A]/5 text-[#166534] border-[#16A34A]/20",
    Nuovo: "bg-[#38BDF8]/10 text-[#0369A1] border-[#38BDF8]/30",
    "Non verificato": "bg-slate-100 text-slate-600 border-slate-200",
    Incoerente: "bg-[#F59E0B]/10 text-[#B45309] border-[#F59E0B]/30",
    Sospetto: "bg-[#DC2626]/10 text-[#DC2626] border-[#DC2626]/30",
    Bloccato: "bg-[#DC2626] text-white border-[#DC2626]",
};

export function SenderStatusBadge({ status = "Non verificato", className = "" }) {
    const v = MAP[status] || MAP["Non verificato"];
    return (
        <span
            data-testid="sender-status-badge"
            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${v} ${className}`}
        >
            {status}
        </span>
    );
}

export default SenderStatusBadge;
